import axios from "axios";
import context from '../main.js'

axios.create({
    // baseURL: '',  // api的base_url
    // withCredentials: true,
    timeout: 60000 // 请求超时时间
});

function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");　　
    return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}

window._axiosPromiseArr = []
axios.interceptors.request.use(config => {
    let cookie = getCookie('Authorization')
    let token =  localStorage.getItem("token") || cookie
        // 在发送请求之前做些什么
    if (token) {
        config.headers['Authorization'] = token;
    }
    config.cancelToken = new axios.CancelToken(cancel => {
        window._axiosPromiseArr.push({ cancel })
    })
    return config;
}, error => { //请求错误处理
    Promise.reject(error)
});

let is401

axios.interceptors.response.use(
    response => {
        if (response.data && response.data.user && response.data.user.token) {
            is401 = false
            let storage = response.data.user.token;
            localStorage.setItem("token", storage)
            localStorage.setItem("firstName", response.data.user.first_name ? response.data.user.first_name : '')
            localStorage.setItem("lastName", response.data.user.last_name ? response.data.user.last_name : '')
            localStorage.setItem("mailbox", response.data.user.mailbox)
            localStorage.setItem('userId', response.data.user.id)
            localStorage.setItem('root_id', response.data.user.root_id)
                // localStorage.setItem('menuList', JSON.stringify(response.data.user.menu_list))
            localStorage.setItem('menuList', response.data.user.menu_list ? JSON.stringify(response.data.user.menu_list) : '')
        }
        if ((response.data.code == '1001002' || response.data.code == '1001000') && !response.data.success) {
            if (is401 || window.location.pathname === '/' || window.location.href.indexOf('redirectUrl') > -1) return
            //vue.$router.push({path:'/'})
            is401 = true
            let pathname = window.location.pathname + window.location.search
            let string = '/?redirectUrl=' + encodeURIComponent(pathname)
            context.$router.push(string)
        }
        if (response.data.code == '1001200') {
            //vue.$router.push({path:'/'})
            context.$message.error("无资金账户")
        }
        if (response.data.code == '1001201') {
            //vue.$router.push({path:'/'})
            context.$message.error("可用资金不足")
        }
        return response
    },
    error => {
        return Promise.reject(error)
    }
);

export default axios


// WEBPACK FOOTER //
// ./src/request/index.js